(function() {
    'use strict';

    angular
        .module('masterApp')
        .controller('ReasonWriteOffDialogController', ReasonWriteOffDialogController);

    ReasonWriteOffDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'ReasonWriteOff','MASTER_CONSTANT'];

    function ReasonWriteOffDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, ReasonWriteOff,MASTER_CONSTANT) {
        var vm = this;
        /*vm.reasonWriteOff1 = [{code:'R01',description:'Phát sử dụng thông thường', note:'nhập lý do vào ô Ghi chú khác',status:'1'},
                             {code:'R02',description:'Phát sử dụng đặt biệt', note:'nhập lý do vào ô Ghi chú khác',status:'1'},
                             {code:'R03',description:'Hủy', note:'nhập lý do vào ô Ghi chú khác',status:'1'},
                             {code:'R04',description:'Mất', note:'nhập lý do vào ô Ghi chú khác',status:'1'},
                             {code:'R05',description:'Tra OP Admin', note:'nhập lý do vào ô Ghi chú khác',status:'1'}];
        vm.reasonWriteOff = vm.reasonWriteOff1[0];*/
        vm.reasonWriteOff = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.lsttypeReason = MASTER_CONSTANT.typeReason;
        vm.checkcreat = false;
        if (vm.reasonWriteOff.reasonId != null || vm.reasonWriteOff.reasonId != undefined) {
       	 vm.checkcreat = true;
       	vm.reasonWriteOff.isExit = true;
        }else{
    	   vm.reasonWriteOff.isExit = false;
        }
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	$scope.clearMessage();
            vm.isSaving = true;
            if (vm.reasonWriteOff.isExit == true) {
            	
            	ReasonWriteOff.update(vm.reasonWriteOff,function(result){
          		  $scope.$emit('masterApp:reasonWriteOffUpdate', result);
                  $uibModalInstance.close(result);
                  vm.isSaving = false;
        	},function(error) {
        		vm.isSaving = false;
		});
            } else {
            	ReasonWriteOff.save(vm.reasonWriteOff,function(result){
        		  $scope.$emit('masterApp:reasonWriteOffUpdate', result);
                  $uibModalInstance.close(result);
                  vm.isSaving = false;
            	},function(error) {
            		vm.isSaving = false;
    		});
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('masterApp:reasonWriteOffUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }



    }
})();
